import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import {
  removeFromWishlist,
  getFromPurchaseRefered,
  getFromCartUser
} from '../../actions';
import { removeFromCart, incrementQty, decrementQty } from '../../actions';
import { removeToCart } from '../../actions';
import { getCartTotal } from '../../services';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import Calendar from '../common/calendar';
import Moment from 'moment';
import store from '../../store';
import Swal from 'sweetalert2';
import VerThanks from '../common/ver-thanks';
import UploadVoucher from '../upload-voucher';
import { v4 as uuidv4 } from 'uuid';

let checkout_items = [];
class UserCheckOut extends Component {
  selectRef = null;
  constructor(props) {
    super(props);
    this.handlePurchase = this.handlePurchase.bind(this);
    this.selectDate = this.selectDate.bind(this);
    this.onChangeCash = this.onChangeCash.bind(this);
    this.gotoHome = this.gotoHome.bind(this);
    this.state = {
      payment: 'stripe',
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      country: '',
      address: '',
      city: '',
      state: '',
      pincode: '',
      create_account: '',
      cash_amount: '',
      show_input_cash: true,
      activeBenefitTab: 'credit',
      code_value: '',
      show_input_code: true,
      show_used_code: false,
      selectedAddressOption: null,
      errors: [
        {
          address: ''
        },
        {
          hour: ''
        },
        {
          cash: false
        },
        {
          code: false
        }
      ],
      data_address: [],
      total_order: 0,
      selectedHourOption: null,
      data_hour: [],
      data_orders: [],
      date: null,
      cash: 0,
      previous_cash: 0,
      new_cash: 0,
      cash_win: 0,
      showThanks: false,
      cost_delivery: 0,
      old_cost_delivery: 0,
      minimum_amount: 0,
      maximum_amount_no_delivery: 0,
      new_orderId: 0,
      showModal: 'none',
      uploadVoucher: '',
      isCheckedDeferredPay: false,
      deferred_pay: '',
      uniqueId: '',
      isUploadingVoucher: false,
      haveVoucher: '',
      // true desde que se sube el comprobante: el pedido ya no se puede
      // modificar (el cliente transfirió por el total que veía).
      cartLocked: false,
      validatingCheckout: false,
      show_used_credit: false,
      total_order_visual: 0,
      discount_code: '',
      count_moreproducts: '',
      // false hasta decidir a dónde va el cliente al entrar (checkout,
      // promociones o /welcome): así el checkout no se pinta para luego saltar.
      entryReady: false
    };

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleVoucherSubmit = this.handleVoucherSubmit.bind(this);
    this.validator = new SimpleReactValidator();
    this.data_hour = [];
  }

  // Pedido bloqueado: comprobante subido (o subiendo) o compra en curso.
  isOrderLocked = () =>
    this.state.cartLocked || this.state.isUploadingVoucher || this.state.loading;

  warnOrderLocked = () => {
    Swal.fire({
      showConfirmButton: false,
      type: 'info',
      title: 'Aviso',
      text:
        'Ya recibimos tu comprobante: tu pedido no se puede modificar. Confirma tu pedido para terminar.',
      timer: 4000
    });
  };

  handleCheckboxChange = () => {
    if (this.isOrderLocked()) {
      this.warnOrderLocked();
      return;
    }
    this.setState(prevState => {
      const newCheckedState = !prevState.isCheckedDeferredPay;

      // Completa el campo hidden si se marca
      return {
        isCheckedDeferredPay: newCheckedState,
        deferred_pay: newCheckedState ? 'DIFERIDO' : 'PAGADO'
      };
    });
  };

  handleShowModal = () => {
    // Subir el comprobante confirma la compra en el mismo paso, así que antes
    // de abrir el modal se valida lo mismo que al comprar (dirección, horario,
    // crédito y monto mínimo). Si falta algo, el cliente lo corrige antes de
    // transferir/subir.
    if (!this.validateCheckout()) {
      return;
    }
    if (this.state.validatingCheckout) {
      return;
    }

    // Y además lo valida el SERVIDOR con el carrito real (mínimo, stock,
    // ventana, crédito, código, montos), sin crear nada: así un problema se ve
    // ANTES de transferir y no después de pagar. Se valida el pedido, no el
    // comprobante (todavía no existe).
    const user = AuthService.getCurrentUser();
    let payload;
    try {
      payload = Object.assign({}, this.buildCheckoutPayload(), {
        deferred_pay: 'DIFERIDO',
        purchase_v: ''
      });
    } catch (e) {
      // Si no se puede armar el pedido (p. ej. el horario elegido ya no está
      // en la lista), no se bloquea el modal: se abre como antes y la compra
      // real resuelve.
      this.setState({ showModal: 'block' }, () => {});
      return;
    }
    const loader = document.getElementsByClassName('page-loader')[0];
    this.setState({ validatingCheckout: true });
    if (loader) loader.style.display = 'flex';

    ApiService.validatePurchaseUser(user.token, payload).then(res => {
      if (loader) loader.style.display = 'none';
      this.setState({ validatingCheckout: false });

      if (res && res.status === 'success') {
        this.setState({ showModal: 'block' }, () => {});
      } else if (res && res.status) {
        this.handleCheckoutError(res);
      } else {
        // No se pudo validar (red, o backend todavía sin esta ruta): se abre
        // igual, como antes -- la compra real vuelve a validar todo.
        this.setState({ showModal: 'block' }, () => {});
      }
    });
  };

  handleCloseModal = () => {
    this.setState({ showModal: 'none' }, () => {});
  };

  generateUniqueId = () => {
    return `VP${uuidv4()}`.toUpperCase();
  };

  handleVoucherSubmit = async acceptedFiles => {
    if (this.state.isUploadingVoucher) return;

    // Reutilizamos el mismo purchaseId si ya se generó antes (reintento tras
    // un error, o doble envío) — así el backend puede detectar el duplicado
    // en vez de recibir un ID distinto cada vez.
    const purchaseId = this.state.uniqueId || this.generateUniqueId();
    this.setState({
      uniqueId: purchaseId,
      isUploadingVoucher: true,
      cartLocked: true
    });

    const formData = new FormData();
    const user = AuthService.getCurrentUser();
    formData.append('file', acceptedFiles[0]);
    formData.append('purchase_id', purchaseId);

    try {
      const response = await ApiService.uploadVoucherTemp(user.token, formData);

      if (response && response.status === 'success') {
        // Subida exitosa → guardar voucher y marcar PAGADO. Reseteamos
        // uniqueId: solo debe reutilizarse durante reintentos de ESTA
        // misma subida; si el usuario vuelve a abrir el modal más tarde
        // en la misma sesión para subir un voucher distinto, necesita un
        // id nuevo o el backend lo tratará como duplicado del anterior.
        // Subir el comprobante confirma la compra en el mismo paso (antes solo
        // se subía la imagen y el cliente, que ya había recibido el WhatsApp
        // de "Pago recibido", creía que el pedido estaba hecho sin pulsar
        // COMPRAR). El pedido queda bloqueado desde aquí.
        this.setState(
          {
            haveVoucher: purchaseId,
            deferred_pay: 'PAGADO',
            uniqueId: '',
            cartLocked: true
          },
          () => {
            this.handleCloseModal();
            this.handlePurchase();
          }
        );
      } else {
        // Fallo en la subida → limpiar y marcar DIFERIDO
        this.setState({
          haveVoucher: '',
          deferred_pay: 'DIFERIDO',
          cartLocked: false
        });

        Swal.fire({
          type: 'error',
          title: 'Error!',
          text: 'No se pudo subir el voucher.'
        });
      }
    } catch (error) {
      // Error en la petición → limpiar y marcar DIFERIDO
      this.setState({
        haveVoucher: '',
        deferred_pay: 'DIFERIDO',
        cartLocked: false
      });

      let message = 'Hubo un problema al subir el voucher.';
      if (
        error &&
        error.response &&
        error.response.data &&
        typeof error.response.data.message === 'string'
      ) {
        message = error.response.data.message;
      }

      Swal.fire({
        type: 'error',
        title: 'Error!',
        text: message
      });
    } finally {
      this.setState({ isUploadingVoucher: false });
    }
  };

  componentWillMount() {
    var user = AuthService.getCurrentUser();
    if (user) {
      document.body.style = `background-color: #161616;font-family: 'Work Sans'`;
      this.checkOpen();
    } else {
      this.props.history.push('/login');
    }
  }

  checkOpen() {
    var user = AuthService.getCurrentUser();
    ApiService.checkOpen(user.token).then(
      (res) => {
        if (res && res.status == 'success') {
          if (res.data.option_value == 'NO') {
            if (window.location.pathname != '/closed') {
              this.props.history.push('/closed');
            }
          } else {
            this.getCheckoutSettings();
            this.getRefOrders();
            this.getUserAddresses();
            this.checkEntry();
            // La fecha empieza vacía y los horarios se consultan recién cuando
            // el cliente la elige (selectDate): antes se asumía "hoy" y se
            // consultaban sus horarios al entrar, aunque no la hubiera elegido.
            this.getCash();
          }
        } else {
          this.props.history.push('/closed');
          window.location.reload();
        }
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    /*if(this.props.cartItems != prevProps.cartItems){
            this.setDataOrder();
        }*/
  }

  getRefOrders() {
    var user = AuthService.getCurrentUser();
    ApiService.getReferredOrders(user.token, user.token_order, user.id).then(
      res => {
        if (res && res.status == 'success') {
          store.dispatch(getFromPurchaseRefered(res.data));
          store.dispatch(getFromCartUser(res.carts_data));

          //this.setState({ order_results:res.data });
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  onChangeCash = e => {
    // El crédito se ingresa en enteros (sin decimales): solo se conservan los dígitos.
    const value = e.target.value.replace(/[^\d]/g, '');

    this.setState({
      cash_amount: value,
      errors: { cash: false }
    });
  };

  onChangeCode = e => {
    const { value } = e.target;
    this.setState({
      code_value: value,
      errors: { code: false }
    });
  };

  selectBenefitTab = tab => {
    this.setState({ activeBenefitTab: tab });
  };

  // Misma lógica que antes tenía la rama "hasLetters" de show_input,
  // ahora disparada explícitamente desde el tab "Código" en vez de
  // detectar letras en un input compartido.
  applyCode = async () => {
    if (this.isOrderLocked()) {
      this.warnOrderLocked();
      return;
    }
    const { code_value, total_order, cost_delivery } = this.state;

    if (!code_value || !code_value.trim()) {
      this.setState({ errors: { code: true } });
      return;
    }

    try {
      var user = AuthService.getCurrentUser();
      const response = await ApiService.validateCode(user.token, {
        code: code_value
      });

      if (response && response.status === 'success') {
        const { discount_value, code } = response;
        const discountValueNumeric = parseFloat(discount_value) || 0;

        // Si el código vale más que los productos, se aplica solo hasta el
        // subtotal (getAppliedCash lo limita); se avisa que el resto se pierde.
        const productsTotal = parseFloat(total_order) || 0;
        if (discountValueNumeric > productsTotal) {
          Swal.fire({
            showConfirmButton: false,
            type: 'info',
            title: 'Aviso',
            text:
              'Tu código es de ' +
              discountValueNumeric.toFixed(2) +
              '; se aplicará ' +
              productsTotal.toFixed(2) +
              ' (el total de tus productos). El resto no se acumula.',
            timer: 5000
          });
        }

        this.setState(
          {
            cash_amount: discountValueNumeric.toFixed(2),
            total_order_visual:
              total_order - discountValueNumeric + parseFloat(cost_delivery),
            show_used_code: true,
            show_input_code: false,
            errors: { code: false },
            discount_code: code
          },
          () => {
            this.updateTotalVisual();
          }
        );
      } else {
        this.setState({
          errors: { code: true }
        });

        Swal.fire({
          showConfirmButton: false,
          type: 'warning',
          title: 'Aviso',
          text: (response && response.message) || 'Código no válido o ya usado.'
        });
      }
    } catch (error) {
      this.setState({
        errors: { code: true }
      });

      Swal.fire({
        showConfirmButton: false,
        type: 'error',
        title: 'Error',
        text: 'Hubo un problema al validar el código.'
      });
    }
  };

  // Misma lógica que antes tenía la rama numérica de show_input,
  // ahora disparada explícitamente desde el tab "Créditos".
  applyCredit = () => {
    if (this.isOrderLocked()) {
      this.warnOrderLocked();
      return;
    }
    const { cash_amount, cash, total_order, cost_delivery } = this.state;
    const cashAmountNumeric = parseFloat(cash_amount) || 0;

    // Crédito: monto entero (sin decimales), de al menos 1 y hasta el saldo.
    // errors.cash guarda el motivo: se muestra bajo el input (el saldo ya se
    // ve en "Crédito actual").
    let cashError = '';
    if (cashAmountNumeric < 1 || cashAmountNumeric % 1 !== 0) {
      cashError = 'Ingresa un monto entero de al menos 1, sin decimales.';
    } else if (cashAmountNumeric > cash) {
      cashError = 'El monto supera tu crédito disponible.';
    }
    if (cashError) {
      this.setState({
        errors: { cash: cashError }
      });

      Swal.fire({
        showConfirmButton: false,
        type: 'warning',
        title: 'Aviso',
        text: cashError
      });
      return;
    }

    const totalOrderNumeric = parseFloat(total_order) || 0;
    const costDeliveryNumeric = parseFloat(cost_delivery) || 0;

    // El crédito no puede superar el total de productos: se aplica lo que
    // alcanza y el resto queda en el saldo.
    const maxCredit = Math.floor(totalOrderNumeric + 0.0001);
    if (maxCredit < 1) {
      this.setState({
        errors: { cash: 'Agrega productos antes de aplicar crédito.' }
      });
      Swal.fire({
        showConfirmButton: false,
        type: 'warning',
        title: 'Aviso',
        text: 'Agrega productos antes de aplicar crédito.'
      });
      return;
    }
    const creditToApply = Math.min(cashAmountNumeric, maxCredit);
    if (creditToApply < cashAmountNumeric) {
      Swal.fire({
        showConfirmButton: false,
        type: 'info',
        title: 'Aviso',
        text:
          'Se aplicarán ' +
          creditToApply +
          ' de crédito (el total de tus productos). El resto queda en tu saldo.',
        timer: 4000
      });
    }

    const updatedTotal =
      totalOrderNumeric - creditToApply + costDeliveryNumeric;

    this.setState(
      {
        cash_amount: String(creditToApply),
        total_order_visual: updatedTotal,
        show_used_credit: true,
        show_input_cash: false,
        errors: { cash: false }
      },
      () => {
        this.updateTotalVisual();
      }
    );
  };

  // Precio de lista (antes de promoción u oferta) de un ítem del carrito. El
  // carrito lo guarda en price_no_discount; Product.old_price queda de respaldo.
  getListPrice = item => {
    const noDiscount = parseFloat(item && item.price_no_discount);
    if (noDiscount > 0) {
      return noDiscount;
    }
    const oldPrice = parseFloat(item && item.Product && item.Product.old_price);
    return oldPrice > 0 ? oldPrice : 0;
  };

  updateTotalVisual = () => {
    const {
      total_order,
      old_cost_delivery,
      maximum_amount_no_delivery
    } = this.state;

    const cashAmountNumeric = this.getAppliedCash();
    const totalOrderNumeric = parseFloat(total_order) || 0;

    // Igual que el backend: el envío gratis se decide sobre el total DESPUÉS de
    // crédito/código, así que al aplicarlos el envío se recalcula.
    const costDeliveryNumeric =
      totalOrderNumeric - cashAmountNumeric >=
      (parseFloat(maximum_amount_no_delivery) || 0)
        ? 0
        : parseFloat(old_cost_delivery) || 0;

    const updatedTotal =
      totalOrderNumeric + costDeliveryNumeric - cashAmountNumeric;

    this.setState({
      cost_delivery: costDeliveryNumeric,
      total_order_visual: updatedTotal
    });
  };

  // Crédito o código que de verdad se aplicó (botón Aplicar). cash_amount
  // cambia mientras el cliente escribe; si no pulsó Aplicar no se descuenta
  // (antes se enviaba igual al backend sin verse en el TOTAL).
  // Nunca supera el total de productos (el backend rechaza un descuento mayor):
  // el crédito se limita al entero más cercano por debajo (lo que sobra queda
  // en el saldo) y el código al subtotal (lo que sobra se pierde). Se calcula
  // en cada render, así que también se ajusta si el carrito baja después.
  getAppliedCash = () => {
    const { show_used_credit, show_used_code, cash_amount, total_order } =
      this.state;
    const amount = parseFloat(cash_amount) || 0;
    const products = parseFloat(total_order) || 0;
    let applied = 0;
    if (show_used_credit) {
      applied = Math.min(amount, Math.floor(products + 0.0001));
    } else if (show_used_code) {
      applied = Math.min(amount, products);
    }
    return Math.max(0, Math.round(applied * 100) / 100);
  };

  // Total a pagar: lo que se muestra en TOTAL y lo que se envía como
  // expected_total salen de aquí, para que nunca difieran.
  getAmountToPay = () =>
    (parseFloat(this.state.total_order) || 0) +
    (parseFloat(this.state.cost_delivery) || 0) -
    this.getAppliedCash();

  gotoHome() {
    this.setState({
      showThanks: true
    });
  }
  // Validaciones previas a comprar; también se usan antes de abrir el modal
  // del comprobante (subirlo confirma la compra). true = se puede continuar.
  validateCheckout = () => {
    // Se marcan TODOS los campos que faltan a la vez y se dice cuáles: los
    // mensajes junto a cada campo quedan arriba de la pantalla y el cliente,
    // que pulsa COMPRAR / Subir voucher abajo, no los veía.
    const missing = [];
    const errors = {};
    if (!this.state.date) {
      missing.push('la fecha de entrega');
      errors.date = 'Error';
    }
    if (!this.state.selectedAddressOption) {
      missing.push('la dirección de entrega');
      errors.address = 'Error';
    }
    if (!this.state.selectedHourOption) {
      missing.push('el horario de entrega');
      errors.hour = 'Error';
    }
    if (missing.length > 0) {
      this.setState({ errors });
      Swal.fire({
        type: 'warning',
        title: 'Falta completar tu pedido',
        text:
          'Elige ' +
          (missing.length > 1
            ? missing.slice(0, -1).join(', ') + ' y ' + missing[missing.length - 1]
            : missing[0]) +
          '.',
        confirmButtonText: 'Entendido'
      }).then(() => this.scrollToFirstError());
      return false;
    }

    // Solo el crédito aplicado se compara contra el saldo (lo escrito sin
    // pulsar Aplicar ya no se envía).
    if (this.state.show_used_credit && this.getAppliedCash() > this.state.cash) {
      this.setState({
        errors: { cash: 'El crédito aplicado es mayor que tu saldo disponible.' }
      });
      Swal.fire({
        type: 'warning',
        title: 'Revisa tu crédito',
        text: 'El crédito aplicado es mayor que tu saldo disponible.',
        confirmButtonText: 'Entendido'
      });
      return false;
    }
    this.setState({ errors: { date: '', address: '', hour: '', cash: false } });

    // Monto mínimo: los ítems (total de productos, antes de crédito/código y
    // sin delivery) siempre deben llegar al mínimo, aunque se use crédito o
    // código. El backend aplica la misma regla.
    if (
      Math.round((parseFloat(this.state.total_order) || 0) * 100) / 100 <
      (parseFloat(this.state.minimum_amount) || 0)
    ) {
      Swal.fire({
        showConfirmButton: false,
        type: 'warning',
        title: 'Aviso!',
        text:
          'El monto mínimo de compra es de ' +
          this.state.minimum_amount +
          ' en productos, antes de aplicar crédito o códigos.',
        timer: 5000
      });
      return false;
    }
    return true;
  };

  // Lleva la pantalla al primer campo con error visible (hay dos maquetas,
  // escritorio y móvil, y solo una se ve a la vez).
  scrollToFirstError = () => {
    const alerts = Array.prototype.slice.call(
      document.querySelectorAll('.alert.ver-alert')
    );
    const visible = alerts.find(el => el.offsetParent !== null);
    if (visible && visible.scrollIntoView) {
      visible.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  // Datos del checkout tal como se envían al servidor (compra real y
  // validación previa al comprobante usan exactamente lo mismo).
  buildCheckoutPayload = () => {
    const user = AuthService.getCurrentUser();
    const hour_programmed = this.data_hour.find(
      x => x.id == this.state.selectedHourOption.value
    );
    return {
      token: user.token_order,
      id_user: user.id,
      date_programmed: this.state.date,
      hour_programmed_start: hour_programmed.start_time,
      hour_programmed_end: hour_programmed.end_time,
      id_address: this.state.selectedAddressOption.value,
      cash: this.getAppliedCash(),
      deferred_pay: this.state.deferred_pay, // ✅ Usamos el valor establecido en handleVoucherSubmit
      purchase_v: this.state.haveVoucher ? this.state.haveVoucher : '',
      discount_code: this.state.discount_code,
      new_checkout: true,
      // Lo que el cliente ve como total a pagar; el servidor lo contrasta con su
      // propio cálculo antes de cobrar.
      expected_total: this.getAmountToPay().toFixed(2)
    };
  };

  // Respuesta de error del checkout (compra real o validación previa al
  // comprobante): cada caso recarga/corrige lo que haga falta y avisa.
  handleCheckoutError = res => {
    res = res || {};
    if (res.status === 'errorcash') {
      // Se quita el crédito/código aplicado (vuelven a verse los inputs) y
      // se recalcula el total. Antes solo se ponía cash_amount en 0 y el
      // beneficio seguía "aplicado" sin forma de quitarlo: con código,
      // cada reintento volvía a fallar.
      // El error se marca en la pestaña del beneficio que se usó: con
      // código ya no sale "Su crédito disponible" bajo el input de crédito.
      const errorMsg = res.mensajeError || 'Ocurrió un error con el monto.';
      const usedCode = this.state.show_used_code;
      this.setState(
        {
          activeBenefitTab: usedCode ? 'code' : 'credit',
          cash_amount: '',
          show_used_credit: false,
          show_used_code: false,
          show_input_cash: true,
          show_input_code: true,
          discount_code: '',
          code_value: '',
          loading: false,
          errors: usedCode ? { code: errorMsg } : { cash: errorMsg }
        },
        () => {
          this.updateTotalVisual();
        }
      );
      Swal.fire({
        showConfirmButton: false,
        type: 'warning',
        title: 'Aviso!',
        html: errorMsg
      });
    } else if (res.stockConflict === true) {
      // Ya no hay stock suficiente de uno o más productos (alguien más
      // se llevó las últimas unidades justo antes). Se recarga el
      // carrito para que la cantidad/disponibilidad se vea real, y se
      // le dice al cliente exactamente qué producto y cuánto hay.
      // Con comprobante subido, se desbloquea el carrito: sin ajustar la
      // cantidad no hay forma de completar el pedido (la diferencia con
      // lo transferido la ve operaciones al revisar el pago).
      this.setState({ loading: false, cartLocked: false });
      this.setDataOrder();

      const productos = res.productos || [];
      const detalle = productos.length
        ? '<br/><br/>' +
          productos
            .map(
              p =>
                '<b>' +
                p.name +
                '</b>: pediste ' +
                p.pedido +
                ', disponible ' +
                p.disponible
            )
            .join('<br/>')
        : '';

      Swal.fire({
        type: 'warning',
        title: 'Stock no disponible',
        html:
          (res.mensajeError ||
            'Uno de los productos de tu pedido ya no tiene stock suficiente.') +
          detalle +
          '<br/><br/>Ajusta la cantidad y vuelve a confirmar.',
        confirmButtonText: 'Entendido'
      });
    } else if (res.minimumAmount === true) {
      // El servidor ve los ítems por debajo del mínimo aunque la pantalla
      // mostraba otro total (p. ej. el carrito cambió en otra pestaña):
      // se recargan carrito y mínimo para que el resumen sea el real.
      // Con comprobante subido se desbloquea el carrito (igual que en
      // stockConflict): sin agregar productos no hay forma de completar
      // el pedido, y el comprobante (haveVoucher) se conserva para
      // confirmar después -- si no, el cliente pagó y queda atrapado.
      this.setState({ loading: false, cartLocked: false });
      this.setDataOrder();
      this.getCheckoutSettings();
      Swal.fire({
        type: 'warning',
        title: 'Monto mínimo no alcanzado',
        html:
          (res.message ||
            'Tu pedido no alcanza el monto mínimo de compra.') +
          '<br/><br/>Actualizamos tu pedido. Agrega productos para continuar.' +
          (this.state.haveVoucher
            ? '<br/><br/>Ya recibimos tu comprobante: agrega productos y confirma tu pedido. Si el total es distinto de lo que transferiste, coordinaremos la diferencia contigo.'
            : ''),
        confirmButtonText: 'Entendido'
      });
    } else if (res.amountMismatch === true) {
      // Los montos del servidor no coinciden con lo que se mostraba: se
      // recarga el carrito y se pide confirmar de nuevo.
      this.setState({ loading: false });
      this.setDataOrder();
      Swal.fire({
        type: 'warning',
        title: 'Revisa tu pedido',
        html:
          (res.mensajeError ||
            'Los montos de tu pedido cambiaron. Revisa el resumen y confirma de nuevo.') +
          (this.state.haveVoucher
            ? '<br/><br/>Ya recibimos tu comprobante. Si el total es distinto de lo que transferiste, coordinaremos la diferencia contigo.'
            : ''),
        confirmButtonText: 'Entendido'
      });
    } else if (res.windowClosed === true) {
      // Ventana de entrega cerrada por saturación
      this.setState({ loading: false, selectedHourOption: null });

      // Refrescar las ventanas disponibles
      let newDate = new Date();
      let current_date = Moment(newDate).format('YYYY-MM-DD');
      let dia_id = Moment(this.state.date).format('d');
      dia_id = dia_id != 0 ? dia_id : 7;

      if (current_date === this.state.date) {
        this.getPickupWindows(dia_id, 1);
      } else {
        this.getPickupWindows(dia_id, 0);
      }

      Swal.fire({
        type: 'warning',
        title: 'Ventana no disponible',
        html:
          res.mensajeError ||
          'La ventana de entrega seleccionada ya no está disponible. Por favor elige otra.',
        confirmButtonText: 'Entendido'
      });
    } else {
      const message_error =
        res.mensajeError || res.message || 'Ocurrió un error desconocido';
      Swal.fire({
        showConfirmButton: false,
        type: 'warning',
        title: 'Aviso!',
        html: message_error
      });
      this.setState({ loading: false });
    }
  };

  handlePurchase(e) {
    if (this.state.data_orders.length > 0) {
      if (!this.validateCheckout()) {
        return false;
      }

      this.setState({ loading: true });

      const user = AuthService.getCurrentUser();
      const data_checkout = this.buildCheckoutPayload();

      document.getElementsByClassName('page-loader')[0].style.display = 'flex';

      ApiService.updatePurchaseUser(user.token, data_checkout).then(
        res => {
          document.getElementsByClassName('page-loader')[0].style.display =
            'none';

          if (res && res.status == 'success') {
            localStorage.removeItem('orders_selected');
            localStorage.removeItem('hasCheckedOpen');
            this.getRefOrders();
            this.getNewCash(res.ganancia_cash);

            if (this.getAppliedCash() > 0) {
              Swal.fire({
                showConfirmButton: false,
                type: 'success',
                title: 'Hecho!',
                // Crédito y código se excluyen en la interfaz: el texto dice cuál
                // se usó (antes decía "crédito" también al pagar con código).
                text: this.state.show_used_code
                  ? 'Pedido confirmado. Tu código ' +
                    this.state.discount_code +
                    ' se aplicó correctamente.'
                  : 'Pedido confirmado. Tu crédito se aplicó correctamente.',
                timer: 2000
              });
              setTimeout(this.gotoHome, 1000);
            } else {
              this.setState({ showThanks: true });
            }
          } else {
            this.handleCheckoutError(res);
          }
        },
        error => {
          document.getElementsByClassName('page-loader')[0].style.display =
            'none';
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.setState({ loading: false });
        }
      );
    }
  }

  selectDate(date) {
    // Nunca una fecha anterior a hoy (el calendario ya lo impide; el backend
    // también la rechaza).
    if (!date || Moment(date).isBefore(Moment(), 'day')) {
      return;
    }
    let newDate = new Date();
    let current_date = Moment(newDate).format('YYYY-MM-DD');
    let dia_id = Moment(date).format('d');
    dia_id = dia_id != 0 ? dia_id : 7;
    let select_date = Moment(date).format('YYYY-MM-DD');
    this.setState({ date: Moment(date).format('YYYY-MM-DD') });
    if (current_date == select_date) {
      this.getPickupWindows(dia_id, 1);
    } else {
      this.getPickupWindows(dia_id, 0);
    }

    this.selectRef.select.clearValue();
  }

  getPickupWindows(id, flag) {
    var user = AuthService.getCurrentUser();
    ApiService.getPickupWindows(user.token, id, flag).then(
      res => {
        if (res && res.status == 'success') {
          this.data_hour = res.data;

          var items = res.data.map(function(row) {
            var start_time = row.start_time.toString();
            var end_time = row.end_time.toString();

            return {
              value: row.id,
              label: start_time.slice(0, -3) + ' - ' + end_time.slice(0, -3),
              key: row.id
            };
          });

          this.setState({ data_hour: items });
          this.renderResults();

          if (items.length == 0) {
            Swal.fire({
              type: 'warning',
              text: 'No hay horario disponible en la fecha seleccionada!'
            });
          }
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  // Devuelve una promesa con los ítems del carrito (undefined si falla).
  setDataOrder() {
    var user = AuthService.getCurrentUser();
    return ApiService.getCartUser(user.token, user.id).then(
      res => {
        if (res && res.status === 'success') {
          checkout_items = res.data;
          if (checkout_items.length === 0 && this.state.showThanks === false) {
            this.props.history.push('/welcome');
          }

          this.setState({ data_orders: checkout_items }, function() {
            let total = 0;
            this.state.data_orders.forEach(function(row) {
              total += row.quantity * row.price;
            });
            // El envío (gratis o no) se decide con el total NUEVO: antes se leía
            // this.state.total_order antes de que se guardara, así que el envío
            // mostrado podía corresponder al carrito anterior.
            this.setState({ total_order: total }, () => {
              this.updateTotalVisual();
            });
          });
          return checkout_items;
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  getCheckoutSettings() {
    var user = AuthService.getCurrentUser();
    ApiService.getCheckoutSettings(user.token).then(
      res => {
        if (res && res.status == 'success') {
          let data = res.data;
          // Se recalcula el envío al llegar el umbral: si el cliente eligió la
          // dirección antes, se había calculado con umbral 0 (envío gratis).
          this.setState(
            {
              minimum_amount: data.minimum_amount.option_value,
              maximum_amount_no_delivery:
                data.maximum_amount_no_delivery.option_value
            },
            () => {
              this.updateTotalVisual();
            }
          );
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  // Al entrar: carrito y promociones (upselling) se consultan en paralelo y,
  // hasta decidir, solo se muestra un spinner. Carrito vacío → /welcome (lo
  // hace setDataOrder); promociones pendientes → /more-products; si no, se
  // muestra el checkout. Antes el checkout se pintaba y luego saltaba, y con el
  // carrito vacío (p. ej. tras una compra) podía terminar en promociones.
  checkEntry() {
    var user = AuthService.getCurrentUser();
    const visitedMoreProducts = localStorage.getItem('hasCheckedOpen');

    // Solo se cuentan promociones que el usuario aún no tiene en el carrito.
    const countPromise = visitedMoreProducts
      ? Promise.resolve(0)
      : ApiService.getCountMoreProducts(user.token, { exclude_in_cart: 1 })
          .then(res => (res && res.status == 'success' ? res.data * 1 || 0 : 0))
          .catch(() => 0);

    Promise.all([this.setDataOrder(), countPromise])
      .then(([items, count]) => {
        if (items && items.length === 0) {
          return; // setDataOrder ya redirige a /welcome
        }
        if (items && count > 0) {
          // Se recuerda desde dónde se llegó para volver ahí al salir de
          // promociones. replace: el checkout nunca se mostró (solo el
          // spinner), así que no debe quedar como paso del historial.
          this.props.history.replace({
            pathname: '/more-products',
            state: { from: window.location.pathname }
          });
          return;
        }
        this.showCheckout();
      })
      .catch(() => {
        this.showCheckout();
      });
  }

  // Muestra el checkout. Los horarios se cargan al elegir la fecha.
  showCheckout() {
    this.setState({ entryReady: true });
  }

  getUserAddresses() {
    var user = AuthService.getCurrentUser();
    ApiService.getUserAddresses(user.token, user.id).then(
      res => {
        if (res && res.status == 'success') {
          this.items = res.data.map(function(row) {
            return {
              value: row.id,
              label: row.type_address + ' ' + row.address + ' ' + row.number,
              key: row.id,
              data: row
            };
          });
          this.setState({ data_address: this.items });
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  checkhandle(value) {
    this.setState({
      payment: value
    });
  }

  handleAddress = selectedAddressOption => {
    if (this.isOrderLocked()) {
      this.warnOrderLocked();
      return;
    }
    const deliveryCost = selectedAddressOption.data.delivery
      ? parseFloat(selectedAddressOption.data.delivery)
      : 0;

    const totalOrder = parseFloat(this.state.total_order) || 0;
    const maxAmountNoDelivery =
      parseFloat(this.state.maximum_amount_no_delivery) || 0;

    // Igual que el backend: el envío gratis se decide sobre el total DESPUÉS de
    // crédito/código.
    const isFreeDelivery =
      totalOrder - this.getAppliedCash() >= maxAmountNoDelivery;

    this.setState(
      {
        selectedAddressOption,
        cost_delivery: isFreeDelivery ? 0 : deliveryCost,
        old_cost_delivery: deliveryCost
      },
      () => {
        this.updateTotalVisual();
      }
    );
  };

  handleHour = selectedHourOption => {
    this.setState({ selectedHourOption });
  };

  WatchOrder = item => {
    for (let i = 0; i < checkout_items.length; i++) {
      checkout_items[i]['visible'] = 0;
    }
    let index = checkout_items.findIndex(x => x.id === item.id);
    checkout_items[index].visible = 1;
    this.setState({ data_orders: checkout_items });
  };

  incrementQty = item => {
    if (this.isOrderLocked()) {
      this.warnOrderLocked();
      return;
    }
    var user = AuthService.getCurrentUser();
    var cart_quantity = item.quantity + 1;
    let data_cart = {
      id_cart: item.id,
      token: user.token_order,
      id_user: user.id,
      id_product: item.id_product,
      quantity: cart_quantity,
      price: item.price
    };

    ApiService.updateCartUser(user.token, data_cart).then(
      res => {
        if (res && res.status == 'success') {
          store.dispatch(incrementQty(data_cart.id_cart));
          var new_data = this.state.data_orders.map(function(row) {
            return {
              id: row.id,
              id_product: row.id_product,
              id_user: row.id_user,
              price: row.price,
              quantity: row.id === item.id ? row.quantity + 1 : row.quantity,
              token: row.token,
              Product: {
                url: row.Product.url,
                name: row.Product.name,
                logo: row.Product.logo
              }
            };
          });

          this.setDataOrder();
        } else {
          if (res.mensajeError) {
            Swal.fire({
              showConfirmButton: false,
              type: 'warning',
              title: 'Aviso!',
              html: res.mensajeError
            });
          } else if (res.message) {
            Swal.fire({
              showConfirmButton: false,
              type: 'warning',
              title: 'Aviso!',
              html: res.message
            });
          }
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  };

  decrementQty = item => {
    if (this.isOrderLocked()) {
      this.warnOrderLocked();
      return;
    }
    var user = AuthService.getCurrentUser();
    var cart_quantity = item.quantity - 1;
    if (cart_quantity == 0) {
      return true;
    }
    let data_cart = {
      id_cart: item.id,
      token: user.token_order,
      id_user: user.id,
      id_product: item.id_product,
      quantity: cart_quantity,
      price: item.price
    };

    ApiService.updateCartUser(user.token, data_cart).then(
      res => {
        if (res && res.status == 'success') {
          store.dispatch(decrementQty(data_cart.id_cart));
          var new_data = this.state.data_orders.map(function(row) {
            return {
              id: row.id,
              id_product: row.id_product,
              id_user: row.id_user,
              price: row.price,
              quantity:
                row.id === item.id && row.quantity > 1
                  ? row.quantity - 1
                  : row.quantity,
              token: row.token,
              Product: {
                url: row.Product.url,
                name: row.Product.name,
                logo: row.Product.logo
              }
            };
          });

          this.setDataOrder();
        } else {
          if (res.mensajeError) {
            Swal.fire({
              showConfirmButton: false,
              type: 'warning',
              title: 'Aviso!',
              html: res.mensajeError
            });
          } else if (res.message) {
            Swal.fire({
              showConfirmButton: false,
              type: 'warning',
              title: 'Aviso!',
              html: res.message
            });
          }
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  };

  showConfirmarPedido() {
    var nextView = false;
    if (!this.state.selectedAddressOption) {
      this.setState({
        errors: { address: 'Error' }
      });
      nextView = false;
      return true;
    } else {
      this.setState({
        errors: { address: '' }
      });
      nextView = true;
    }

    if (!this.state.selectedHourOption) {
      this.setState({
        errors: { hour: 'Error' }
      });
      nextView = false;
      return true;
    } else {
      this.setState({
        errors: { hour: '' }
      });
      nextView = true;
    }

    if (nextView == true) {
      document.getElementById('verDireccionHora').style.display = 'none';
      document.getElementById('verConfirmarPedido').style.display = 'block';
    }
  }

  showDireccionHora() {}

  removeFromCartUpdate = item => {
    if (this.isOrderLocked()) {
      this.warnOrderLocked();
      return;
    }
    if (item && item.id > 0 && item.Product) {
      Swal.fire({
        title: 'Confirmar',
        text: '¿Desea eliminar el producto ' + item.Product.name + '?',
        //type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.value) {
          var user = AuthService.getCurrentUser();
          ApiService.deleteCartUser(user.token, item.id).then(
            res => {
              if (res && res.status == 'success') {
                store.dispatch(removeFromCart(item));
                this.getRefOrders();
                this.setDataOrder();
                Swal.fire({
                  type: 'success',
                  title: 'Hecho!',
                  text: 'Producto Eliminado!',
                  timer: 1500
                });
              } else {
                if (res.mensajeError) {
                  Swal.fire({
                    showConfirmButton: false,
                    type: 'warning',
                    title: 'Aviso!',
                    html: res.mensajeError
                  });
                } else if (res.message) {
                  Swal.fire({
                    showConfirmButton: false,
                    type: 'warning',
                    title: 'Aviso!',
                    html: res.message
                  });
                }
              }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        }
      });
    }
  };

  getCash() {
    var user = AuthService.getCurrentUser();
    AuthService.getCash(user.token).then(
      res => {
        if (res && res.status == 'success') {
          let cash_amount =
            res && res.data && res.data.amount_cash
              ? Math.round(res.data.amount_cash * 100) / 100
              : 0;
          //this.setState({ cash_amount: cash_amount });
          this.setState({ cash: cash_amount });
          this.setState({ previous_cash: cash_amount });
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  // this.getNewCash(gananciaCash): refresca el crédito disponible (para
  // "Tu crédito actual es") tras la compra. cash_win ya NO se recalcula acá --
  // antes se adivinaba con una resta de saldos que usaba un 20% que no
  // corresponde a este flujo (era el de otro tipo de compra) y que además no
  // sabía que un código de descuento no descuenta del saldo, así que casi
  // siempre daba negativo y el aviso "Has Acumulado" no llegaba a mostrarse.
  // Ahora el monto viene directo de la respuesta del servidor
  // (checkoutPurchaseUser ya lo calcula para acreditarlo).
  getNewCash(gananciaCash) {
    var user = AuthService.getCurrentUser();
    AuthService.getCash(user.token).then(
      res => {
        if (res && res.status == 'success') {
          let cash_amount =
            res && res.data && res.data.amount_cash
              ? Math.round(res.data.amount_cash * 100) / 100
              : 0;
          this.setState({
            cash: cash_amount,
            new_cash: cash_amount,
            cash_win: Math.round((parseFloat(gananciaCash) || 0) * 100) / 100
          });
        }
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }

  renderResults() {
    const { selectedHourOption } = this.state;
    const customStyles = {
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        // const color = chroma(data.color);
        return {
          ...styles,
          backgroundColor: isFocused ? '#161616' : '#161616',
          color: isFocused ? '#F8EEE1' : '#F8EEE1'
        };
      },
      placeholder: defaultStyles => {
        return {
          ...defaultStyles,
          position: 'absolute',
          display: 'inherit',
          paddingLeft: '2px'
        };
      },
      control: (base, state) => ({
        ...base,
        background: '#161616',
        //opacity: 0.5,
        border: '2px solid #F8EEE1',
        //color: "#cfd4da",
        borderRadius: 30,
        backgroundColor: state.isFocused ? '#161616' : null
      }),
      singleValue: (base, state) => ({
        ...base,
        color: '#F8EEE1',
        position: 'absolute',
        display: 'inherit',
        paddingLeft: '2px'
      }),
      input: (base, state) => ({
        ...base,
        position: 'absolute',
        color: '#F8EEE1'
      }),
      valueContainer: (base, state) => ({
        ...base,
        minHeight: 'inherit'
      })
    };

    return (
      <Select
        ref={ref => {
          this.selectRef = ref;
        }}
        value={selectedHourOption}
        onChange={this.handleHour}
        options={this.state.date ? this.state.data_hour : []}
        isDisabled={!this.state.date}
        placeholder={this.state.date ? 'Seleccione' : 'Primero elige la fecha'}
        noOptionsMessage={() => 'No hay horarios para esta fecha'}
        styles={customStyles}
      />
    );
  }

  render() {
    if (!this.state.entryReady && !this.state.showThanks) {
      document.body.classList.add('dark');
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div className="spinner-border" style={{ color: '#00ff08' }}></div>
        </div>
      );
    }

    const { cartItems, total } = this.props;
    const symbol = (
      <img
        src={`${process.env.PUBLIC_URL}/assets/images/icon/credit.png`}
        alt=""
        className="img-fluid"
        style={{
          width: 'auto',
          height: '20px',
          bottom: '2px'
        }}
      />
    );

    const symbolUpload = (
      <img
        src={`${process.env.PUBLIC_URL}/assets/images/icon/upload.svg`}
        alt=""
        className="img-fluid"
        style={{
          width: 'auto',
          height: '20px',
          bottom: '2px'
        }}
      />
    );

    // Subtotal = suma de precios de lista (antes de promo) de cada producto.
    // Si el producto no trae precio de lista (old_price), se usa el precio
    // actual como base y el descuento de ese ítem queda en 0.
    const productsSubtotal = this.state.data_orders.reduce((acc, item) => {
      const listPrice =
        this.getListPrice(item) || parseFloat(item.price) || 0;
      return acc + listPrice * item.quantity;
    }, 0);
    const productsDiscount = Math.max(
      0,
      productsSubtotal - (parseFloat(this.state.total_order) || 0)
    );

    document.body.classList.add('dark');

    // Paypal Integration
    const onSuccess = payment => {
      this.props.history.push({
        pathname: '/order-success',
        state: {
          payment: payment,
          items: cartItems,
          orderTotal: total,
          symbol: symbol
        }
      });
    };

    const onCancel = data => {};

    const onError = err => {};

    const client = {
      sandbox:
        'AZ4S98zFa01vym7NVeo_qthZyOnBhtNvQDsjhaZSMH-2_Y9IAJFbSD3HPueErYqN8Sa8WYRbjP7wWtd_',
      production:
        'AZ4S98zFa01vym7NVeo_qthZyOnBhtNvQDsjhaZSMH-2_Y9IAJFbSD3HPueErYqN8Sa8WYRbjP7wWtd_'
    };

    const { selectedAddressOption } = this.state;
    //const { selectedHourOption } = this.state;
    const customStyles = {
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        // const color = chroma(data.color);
        return {
          ...styles,
          backgroundColor: isFocused ? '#161616' : '#161616',
          color: isFocused ? '#F8EEE1' : '#F8EEE1'
        };
      },
      placeholder: defaultStyles => {
        return {
          ...defaultStyles,
          position: 'absolute',
          display: 'inherit',
          paddingLeft: '2px'
        };
      },
      control: (base, state) => ({
        ...base,
        background: '#161616',
        border: '2px solid #F8EEE1',
        borderRadius: 30,
        backgroundColor: state.isFocused ? '#161616' : null
      }),
      singleValue: (base, state) => ({
        ...base,
        color: '#F8EEE1',
        position: 'absolute',
        display: 'inherit',
        paddingLeft: '2px'
      }),
      input: (base, state) => ({
        ...base,
        position: 'absolute',
        color: '#F8EEE1'
      }),
      valueContainer: (base, state) => ({
        ...base,
        minHeight: 'inherit'
      })
    };

    return (
      <div
        className="cart-container ref-chk-container"
        style={{ backgroundColor: '#161616 !important' }}
      >
        {this.state.showThanks == false ? (
          <section id="ver-section-buy" className="section-b-space checkout-preview-only">
            <div className="container padding-cls">
              <div className="checkout-page">
                <div className="checkout-form">
                  <form>
                    <div className="checkout row">
                      {
                        <div
                          id="verDireccionHora"
                          className="col-lg-12 col-sm-12 col-xs-12"
                          style={{ display: 'none' }}
                        >
                          <div style={{ marginBottom: '1.5rem' }}>
                            <div
                              className="row"
                              style={{ marginBottom: '1.5rem' }}
                            >
                              <div className="col-md-6 col-sm-6 offset-md-3 offset-sm-3 col-xs-6 offset-xs-3">
                                <div
                                  className="page-title page-tittle2"
                                  style={{ textAlign: 'center' }}
                                >
                                  {/*<h1>{title}</h1>*/}
                                  <label className="text-confirm-order">
                                    ELIGE DIRECCIÓN, DÍA Y HORA DE ENTREGA
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div
                              className="referred-checkout-title"
                              style={{ textAlign: 'center' }}
                            >
                              <label>Tus direcciones</label>
                            </div>
                            <div className="row check-out">
                              <div
                                className="form-group col-md-4 col-sm-4 col-xs-12"
                                style={{ margin: '0 auto' }}
                              >
                                {/*<div className="field-label">Dirección</div>*/}
                                <Select
                                  value={selectedAddressOption}
                                  isDisabled={this.state.cartLocked}
                                  onChange={this.handleAddress}
                                  options={this.state.data_address}
                                  placeholder={'Seleccione'}
                                  styles={customStyles}
                                />
                                {this.state.errors.address &&
                                !this.state.selectedAddressOption ? (
                                  <div
                                    className="alert alert-danger ver-alert"
                                    role="alert"
                                  >
                                    Este campo es obligatorio!
                                  </div>
                                ) : (
                                  ''
                                )}
                                {/*<input type="text" name="address" value={this.state.address} onChange={this.setStateFromInput} placeholder="Street address" />
                                                        {this.validator.message('address', this.state.address, 'required|min:20|max:120')}*/}
                              </div>
                            </div>
                          </div>
                          <div style={{ marginBottom: '1.5rem' }}>
                            <div
                              className="referred-checkout-title"
                              style={{ textAlign: 'center' }}
                            >
                              <label>DÍA</label>
                            </div>
                            <div>
                              <div
                                className="row check-out row-check-date"
                                style={{ textAlign: 'center' }}
                              >
                                <div
                                  className="form-group col-md-4 col-sm-4 col-xs-12"
                                  style={{ margin: '0 auto' }}
                                >
                                  {/*<div className="field-label">Fecha</div>*/}
                                  <Calendar
                                    handleDateChange={this.selectDate}
                                    emptyStart
                                  />
                                  {this.state.errors.date && !this.state.date ? (
                                    <div
                                      className="alert alert-danger ver-alert"
                                      role="alert"
                                    >
                                      Este campo es obligatorio!
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div
                              className="referred-checkout-title"
                              style={{ textAlign: 'center' }}
                            >
                              <label>HORA</label>
                            </div>
                            <div className="row check-out ">
                              <div
                                className="form-group col-md-4 col-sm-4 col-xs-12"
                                style={{ margin: '0 auto' }}
                              >
                                {/*<div className="field-label">Hora</div>*/}
                                {this.renderResults()}
                                {this.state.errors.hour &&
                                !this.state.selectedHourOption ? (
                                  <div
                                    className="alert alert-danger ver-alert"
                                    role="alert"
                                  >
                                    Este campo es obligatorio!
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row chk-cart-buttons">
                            <div className="col-12 cart-btn-checkout">
                              <button
                                type="button"
                                className="btn btn-solid btn-referred-checkout"
                                disabled={this.state.loading}
                                onClick={() => this.showConfirmarPedido()}
                              >
                                CONFIRMAR
                              </button>
                            </div>
                          </div>
                        </div>
                      }

                      {
                        <div
                          id="verConfirmarPedido"
                          className="col-lg-12 col-sm-12 col-xs-12 ref-container-checkout-details"
                          style={{ display: 'block' }}
                        >
                          <div style={{ marginBottom: '1.5rem' }}>
                            <div
                              className="container"
                              style={{ marginBottom: '1.5rem' }}
                            >
                              <div
                                className="page-title page-tittle2"
                                style={{ textAlign: 'left' }}
                              >
                                <label className="text-confirm-order">
                                  1- DATOS DE ENVIO
                                </label>
                              </div>
                            </div>

                            <div className="container cont_lugar">
                              <div className="row">
                                <div
                                  className="col-2"
                                  style={{
                                    marginRight: '-16px',
                                    marginTop: '0.4rem'
                                  }}
                                >
                                  <img
                                    src="/assets/images/icon/geo-alt (1).png"
                                    alt=""
                                    className="img-fluid"
                                  />
                                </div>
                                <div
                                  className="col-3 referred-checkout-title"
                                  style={{
                                    textAlign: 'left',
                                    paddingLeft: '0',
                                    marginTop: '0.5rem'
                                  }}
                                >
                                  <label>¿Lugar?</label>
                                </div>
                                <div className="col-7 check-out">
                                  <div
                                    className="form-group"
                                    style={{ margin: '0 auto' }}
                                  >
                                    <Select
                                      value={selectedAddressOption}
                                      isDisabled={this.state.cartLocked}
                                      onChange={this.handleAddress}
                                      options={this.state.data_address}
                                      placeholder={'Seleccione'}
                                      styles={customStyles}
                                    />
                                    {this.state.errors.address &&
                                    !this.state.selectedAddressOption ? (
                                      <div
                                        className="alert alert-danger ver-alert"
                                        role="alert"
                                      >
                                        Este campo es obligatorio!
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className="container cont_dia"
                            style={{ marginBottom: '1.5rem' }}
                          >
                            <div className="row">
                              <div
                                className="col-2"
                                style={{
                                  marginRight: '-16px',
                                  marginTop: '0.4rem'
                                }}
                              >
                                <img
                                  src="/assets/images/icon/calendar.png"
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                              <div
                                className="col-3 referred-checkout-title"
                                style={{
                                  textAlign: 'left',
                                  paddingLeft: '0',
                                  marginTop: '0.5rem'
                                }}
                              >
                                <label>¿Día?</label>
                              </div>
                              <div className="col-7 check-out row-check-date">
                                <div
                                  className="form-group dp-full-width"
                                  style={{ margin: '0 auto' }}
                                >
                                  <Calendar
                                    handleDateChange={this.selectDate}
                                    emptyStart
                                  />
                                  {this.state.errors.date && !this.state.date ? (
                                    <div
                                      className="alert alert-danger ver-alert"
                                      role="alert"
                                    >
                                      Este campo es obligatorio!
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className="container cont_hora"
                            style={{ marginBottom: '1.5rem' }}
                          >
                            <div className="row">
                              <div
                                className="col-2"
                                style={{
                                  marginRight: '-16px',
                                  marginTop: '0.4rem'
                                }}
                              >
                                <img
                                  src="/assets/images/icon/clock.png"
                                  alt=""
                                  className="img-fluid"
                                />
                              </div>
                              <div
                                className="col-3 referred-checkout-title"
                                style={{
                                  textAlign: 'left',
                                  paddingLeft: '0',
                                  marginTop: '0.5rem'
                                }}
                              >
                                <label>¿Hora?</label>
                              </div>
                              <div className="col-7 check-out">
                                <div
                                  className="form-group"
                                  style={{ margin: '0 auto' }}
                                >
                                  {this.renderResults()}
                                  {this.state.errors.hour &&
                                  !this.state.selectedHourOption ? (
                                    <div
                                      className="alert alert-danger ver-alert"
                                      role="alert"
                                    >
                                      Este campo es obligatorio!
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="container">
                            <div
                              className="page-title page-tittle2"
                              style={{ textAlign: 'left' }}
                            >
                              <label className="text-confirm-order">
                                2- REVISA TU ORDEN
                              </label>
                            </div>
                          </div>

                          <div
                            className="container checkout-details ref-checkout-details cart-box"
                            style={{
                              marginTop: '0rem'
                            }}
                          >
                            <div className="order-box checkout-order-box chk-ref-total">
                              <div className="cart-box-header">
                                <img
                                  src={`${process.env.PUBLIC_URL}/assets/images/icon/cart-outline.svg`}
                                  alt=""
                                  className="benefits-icon"
                                />
                                <span>TU CANASTA</span>
                                <span className="cart-box-count">
                                  ({this.state.data_orders.length} producto
                                  {this.state.data_orders.length === 1
                                    ? ''
                                    : 's'}
                                  )
                                </span>
                              </div>

                              <ul className="cart-item-list">
                                {this.state.data_orders.map((item, index) => {
                                  const productName =
                                    item && item.Product && item.Product.name
                                      ? item.Product.name
                                      : item && item.name
                                      ? item.name
                                      : '';
                                  const productSize =
                                    item && item.Product && item.Product.size
                                      ? ' - ' + item.Product.size
                                      : '';
                                  const unitPrice = parseFloat(item.price) || 0;
                                  const unitOldPrice = this.getListPrice(item);
                                  const hasDiscount = unitOldPrice > unitPrice;
                                  const currentTotal = (
                                    unitPrice * item.quantity
                                  ).toFixed(2);
                                  const oldTotal = (
                                    unitOldPrice * item.quantity
                                  ).toFixed(2);

                                  return (
                                    <li key={index} className="cart-item">
                                      <div className="cart-item-img">
                                        <img
                                          src={
                                            `${process.env.REACT_APP_URL_FILES}images/products/` +
                                            (item &&
                                            item.Product &&
                                            item.Product.url
                                              ? item.Product.url
                                              : item &&
                                                item.Product &&
                                                item.Product.logo
                                              ? item.Product.logo
                                              : '')
                                          }
                                          alt=""
                                        />
                                      </div>

                                      <div className="cart-item-body">
                                        <div className="cart-item-top">
                                          <span className="cart-item-name">
                                            {productName}
                                            {productSize}
                                          </span>
                                          {hasDiscount && (
                                            <span className="cart-item-promo">
                                              PROMO
                                            </span>
                                          )}
                                          <button
                                            type="button"
                                            className="cart-item-remove"
                                            disabled={this.state.cartLocked}
                                            onClick={() =>
                                              this.removeFromCartUpdate(item)
                                            }
                                          >
                                            <i className="icon-close"></i>
                                          </button>
                                        </div>

                                        <div className="cart-item-bottom">
                                          <div className="cart-item-qty">
                                            <button
                                              type="button"
                                              disabled={this.state.cartLocked}
                                              onClick={() =>
                                                this.decrementQty(item)
                                              }
                                              data-type="minus"
                                              data-field=""
                                            >
                                              <i className="fa fa-minus"></i>
                                            </button>
                                            <span>{item.quantity}</span>
                                            <button
                                              type="button"
                                              disabled={this.state.cartLocked}
                                              onClick={() =>
                                                this.incrementQty(item)
                                              }
                                              data-type="plus"
                                              data-field=""
                                            >
                                              <i className="fa fa-plus"></i>
                                            </button>
                                          </div>

                                          <div className="cart-item-price">
                                            {hasDiscount && (
                                              <span className="cart-item-price-old">
                                                {symbol}
                                                {oldTotal}
                                              </span>
                                            )}
                                            <span className="cart-item-price-current">
                                              {symbol}
                                              {currentTotal}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>

                          <div
                            className="container qty-box quanty-categ-prod categ-prod-buttons benefits-box"
                            style={{ marginBottom: '0rem' }}
                          >
                            <div className="benefits-box-header">
                              <span className="benefits-box-title">
                                <img
                                  src={`${process.env.PUBLIC_URL}/assets/images/icon/tag.svg`}
                                  alt=""
                                  className="benefits-icon"
                                />
                                APLICA TUS BENEFICIOS
                              </span>
                              <span className="benefits-box-hint">
                                Usa solo uno
                              </span>
                            </div>

                            {!this.state.show_used_credit &&
                              !this.state.show_used_code && (
                                <div className="benefits-tabs">
                                  <button
                                    type="button"
                                    className={
                                      'benefits-tab' +
                                      (this.state.activeBenefitTab === 'credit'
                                        ? ' active'
                                        : '')
                                    }
                                    onClick={() =>
                                      this.selectBenefitTab('credit')
                                    }
                                  >
                                    {symbol} Créditos
                                  </button>
                                  <button
                                    type="button"
                                    className={
                                      'benefits-tab' +
                                      (this.state.activeBenefitTab === 'code'
                                        ? ' active'
                                        : '')
                                    }
                                    onClick={() =>
                                      this.selectBenefitTab('code')
                                    }
                                  >
                                    <img
                                      src={`${process.env.PUBLIC_URL}/assets/images/icon/${
                                        this.state.activeBenefitTab === 'code'
                                          ? 'ticket-dark.svg'
                                          : 'ticket.svg'
                                      }`}
                                      alt=""
                                      className="benefits-icon benefits-icon-wide"
                                    />
                                    Código
                                  </button>
                                </div>
                              )}

                            {/* Tab: Créditos */}
                            {this.state.activeBenefitTab === 'credit' &&
                              !this.state.show_used_credit &&
                              !this.state.show_used_code && (
                                <div className="benefit-tab-content">
                                  <div className="chk-credit">
                                    <span>Crédito actual: </span>
                                    <span>
                                      {symbol} {this.state.cash}
                                    </span>
                                  </div>

                                  <div className="form-group apply-credit-container benefit-input-row">
                                    <input
                                      className="input-apply-credit"
                                      type="text"
                                      name="cash"
                                      value={this.state.cash_amount}
                                      onChange={this.onChangeCash}
                                      inputMode="numeric"
                                      placeholder="Ingresa crédito a descontar"
                                    />
                                    <button
                                      type="button"
                                      className="btn-apply-credit"
                                      disabled={this.state.cartLocked}
                                      onClick={this.applyCredit}
                                    >
                                      APLICAR
                                    </button>
                                  </div>
                                  {this.state.errors.cash && (
                                    <div
                                      className="alert alert-danger ver-alert"
                                      role="alert"
                                    >
                                      {typeof this.state.errors.cash === 'string'
                                        ? this.state.errors.cash
                                        : 'Revisa el monto de crédito.'}
                                    </div>
                                  )}
                                </div>
                              )}

                            {/* Tab: Código */}
                            {this.state.activeBenefitTab === 'code' &&
                              !this.state.show_used_credit &&
                              !this.state.show_used_code && (
                                <div className="benefit-tab-content">
                                  <div className="form-group apply-credit-container benefit-input-row">
                                    <input
                                      className="input-apply-credit"
                                      type="text"
                                      name="code"
                                      value={this.state.code_value}
                                      onChange={this.onChangeCode}
                                      placeholder="Ingresa tu código"
                                    />
                                    <button
                                      type="button"
                                      className="btn-apply-credit"
                                      disabled={this.state.cartLocked}
                                      onClick={this.applyCode}
                                    >
                                      APLICAR
                                    </button>
                                  </div>
                                  {this.state.errors.code && (
                                    <div
                                      className="alert alert-danger ver-alert"
                                      role="alert"
                                    >
                                      {typeof this.state.errors.code === 'string'
                                        ? this.state.errors.code
                                        : 'Código no válido o ya usado.'}
                                    </div>
                                  )}
                                </div>
                              )}

                            {/* Mensaje de confirmación (en verde) */}
                            {this.state.show_used_credit && (
                              <div className="benefit-applied-msg">
                                Aplicaste {symbol}{' '}
                                {this.getAppliedCash().toFixed(2)}{' '}
                                en créditos
                              </div>
                            )}
                            {this.state.show_used_code && (
                              <div className="benefit-applied-msg">
                                Aplicaste {symbol}{' '}
                                {this.getAppliedCash().toFixed(2)}{' '}
                                con el código {this.state.discount_code}
                              </div>
                            )}
                          </div>

                          <div className="container checkout-details ref-checkout-details order-summary-box">
                            <div className="order-box checkout-order-box chk-ref-total">
                              <div className="order-summary-header">
                                <img
                                  src={`${process.env.PUBLIC_URL}/assets/images/icon/summary.svg`}
                                  alt=""
                                  className="benefits-icon"
                                />
                                <span>RESUMEN</span>
                              </div>

                              <ul className="order-summary-list">
                                <li>
                                  <label>Subtotal</label>
                                  <span>{productsSubtotal.toFixed(2)}</span>
                                </li>

                                {productsDiscount > 0 && (
                                  <li>
                                    <label>Descuentos de productos</label>
                                    <span>- {productsDiscount.toFixed(2)}</span>
                                  </li>
                                )}

                                {(this.state.show_used_credit ||
                                  this.state.show_used_code) && (
                                  <li>
                                    <label>
                                      {this.state.show_used_code
                                        ? 'Código ' + this.state.discount_code
                                        : 'Créditos aplicados'}
                                    </label>
                                    <span>
                                      -{' '}
                                      {this.getAppliedCash().toFixed(2)}
                                    </span>
                                  </li>
                                )}

                                <li>
                                  <label>Envío</label>
                                  <span>
                                    {parseFloat(
                                      this.state.cost_delivery
                                    ).toFixed(2)}
                                  </span>
                                </li>
                              </ul>

                              <div className="order-summary-total">
                                <label>TOTAL</label>
                                <span className="count user-orders-total">
                                  {symbol}
                                  {this.getAmountToPay().toFixed(2)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      }

                      {/* Envuelto igual que "#verConfirmarPedido" (misma clase de columna,
    sin ".checkout-details") para que absorba el margen negativo de
    ".checkout.row" — si no, esta tarjeta y "Seguir comprando" quedan
    30px más anchas que las otras 3 tarjetas y los campos de arriba. */}
                      <div className="col-lg-12 col-sm-12 col-xs-12">
                        <div
                          className="container checkout-details ref-checkout-details payment-box"
                          style={{ marginBottom: '0rem' }}
                        >
                          <div className="order-box checkout-order-box chk-ref-total">
                            <div className="payment-box-header">
                              <img
                                src={`${process.env.PUBLIC_URL}/assets/images/icon/upload-outline.svg`}
                                alt=""
                                className="benefits-icon"
                              />
                              <span>¿YA PAGASTE?</span>
                            </div>

                            {/* nuevo botón para modal Subir voucher. Con el
                                comprobante ya subido (y la confirmación
                                pendiente, p. ej. tras un error) solo queda
                                confirmar el pedido. */}
                            {!this.state.haveVoucher ? (
                              <React.Fragment>
                                <button
                                  type="button"
                                  className="voucher-upload-box"
                                  onClick={this.handleShowModal}
                                  disabled={this.isOrderLocked()}
                                >
                                  {symbolUpload}
                                  <span>Subir voucher</span>
                                </button>
                                <p className="payment-box-hint">
                                  Tu orden se confirma automáticamente al subirlo.
                                </p>
                              </React.Fragment>
                            ) : (
                              <p className="payment-box-hint">
                                Recibimos tu comprobante. Confirma tu pedido para
                                terminar.
                              </p>
                            )}

                            {/* Componente UploadVoucher */}
                            <UploadVoucher
                              showOverlay={this.state.showModal}
                              setShowOverlay={this.handleCloseModal}
                              handleVoucherSubmit={this.handleVoucherSubmit}
                              isUploadingVoucher={this.state.isUploadingVoucher}
                            />
                            {/* end - nuevo botón para modal Subir voucher */}

                            {!this.state.haveVoucher && (
                              <React.Fragment>
                                <div className="payment-divider">
                                  <span>o</span>
                                </div>

                                <p className="payment-box-hint">
                                  Compra ahora y paga en máximo 2 días.
                                </p>
                              </React.Fragment>
                            )}
                            <input
                              type="hidden"
                              value={this.state.deferred_pay}
                              id="deferred_pay"
                            />

                            <button
                              type="button"
                              className="btn-buy-now"
                              disabled={
                                this.state.loading || this.state.isUploadingVoucher
                              }
                              onClick={() => this.handlePurchase()}
                            >
                              {this.state.haveVoucher ? 'CONFIRMAR PEDIDO' : 'COMPRAR'}
                            </button>
                          </div>
                        </div>

                        {/* Con el comprobante subido no se ofrece salir: el
                            comprobante vive solo en esta pantalla y se
                            perdería el vínculo con el pedido. */}
                        {!this.state.haveVoucher && (
                          <div className="container chk-cart-buttons">
                            <div className="col-12 cart-btn-keep-shopping">
                              <Link
                                to={`${process.env.PUBLIC_URL}/welcome`}
                                className=""
                              >
                                Seguir comprando
                              </Link>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <VerThanks cash={this.state.cash} cash_win={this.state.cash_win} />
        )}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  cartItems: state.cartList.cart,
  symbol: state.data.symbol,
  total: getCartTotal(state.cartList.cart)
});

export default connect(mapStateToProps, {
  removeFromWishlist,
  removeToCart,
  removeFromCart,
  incrementQty,
  decrementQty
})(UserCheckOut);
